import { useParams, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"
import {
  Box, Typography, CircularProgress, Card, CardContent,
  Button, IconButton, Avatar
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar"
import PhoneIcon from "@mui/icons-material/Phone"
import RoomIcon from "@mui/icons-material/Room"
import FlagIcon from "@mui/icons-material/Flag"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import RefreshIcon from "@mui/icons-material/Refresh"
import logoSrc from "../../assets/icons/menu_icons/logo.svg"

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    background: "#f5f7fa",
    fontFamily: theme.typography.fontFamily,
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    padding: "20px",
  },
  contentInner: {
    maxWidth: 1000,
    margin: "0 auto",
    width: "100%",
  },
  header: {
    background: "linear-gradient(174.61deg, #1EAAC4 0%, #10658E 104.65%)",
    padding: "20px",
  },
  headerContent: {
    maxWidth: 1000,
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 16,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 600,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  headerRight: {
    display: "flex",
    gap: 16,
    alignItems: "center",
  },
  headerStat: {
    fontSize: 14,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  dateHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 4px",
    marginBottom: 4,
  },
  dateLabel: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1a1a1a",
  },
  dateCount: {
    fontSize: 12,
    fontWeight: 600,
    color: "#888",
  },

  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  emptyState: {
    padding: "40px 24px",
    background: "#fff",
    borderRadius: 12,
  },
  emptyInner: {
    maxWidth: 1000,
    margin: "0 auto",
  },
  emptyIcon: {
    fontSize: 80,
    color: "#d0d0d0",
    marginBottom: 16,
  },
  emptyTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#1a1a1a",
    marginBottom: 8,
  },
  emptyMsg: {
    fontSize: 14,
    color: "#888",
    lineHeight: 1.6,
  },
  card: {
    borderRadius: 12,
    marginBottom: 16,
    cursor: "pointer",
    transition: "all 0.2s ease",
    border: "1px solid #e5e7eb",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",

    "&:hover": {
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      borderColor: "#d1d5db",
    },
  },
  cardContent: {
    padding: "18px !important",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
    gap: 12,
  },
  clientSection: {
    flex: 1,
  },
  clientName: {
    fontSize: 16,
    fontWeight: 700,
    color: "#1a1a1a",
    marginBottom: 4,
  },
  studentCount: {
    fontSize: 13,
    color: "#888",
    fontWeight: 500,
  },
  statusChip: {
    fontSize: 11,
    fontWeight: 700,
  },
  infoGroup: {
    marginBottom: 12,

    "&:last-child": {
      marginBottom: 0,
    },
  },
  infoRow: {
    display: "flex",
    gap: 12,
    alignItems: "flex-start",
    marginBottom: 10,

    "&:last-child": {
      marginBottom: 0,
    },
  },
  infoIcon: {
    fontSize: 20,
    marginTop: 1,
    flexShrink: 0,
    color: "#666",
  },
  infoContent: {
    flex: 1,
  },
  infoLabel: {
    fontSize: 11,
    color: "#999",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.3,
    marginBottom: 3,
  },
  infoText: {
    fontSize: 14,
    color: "#333",
    fontWeight: 500,
    lineHeight: 1.5,
  },
  driverRow: { display: "flex", alignItems: "center", gap: 12, marginTop: 12, paddingTop: 12, borderTop: "1px solid #e5e7eb" },
  driverName: { fontSize: 15, fontWeight: 700, color: "#1a1a1a" },
  driverPhone: { fontSize: 13, color: "#666", marginTop: 2 },
  statusBadge: {
    display: "inline-flex", alignItems: "center", padding: "4px 12px", borderRadius: 20,
    fontSize: 12, fontWeight: 600, letterSpacing: 0.3
  },
  vehicleTag: {
    display: "inline-block", padding: "3px 10px", borderRadius: 8,
    background: "#e8f0fe", color: "#1a73e8", fontSize: 12, fontWeight: 500,
    marginRight: 6, marginBottom: 4
  },
  trackBtn: {
    fontSize: 12, color: "#1a73e8", fontWeight: 700, cursor: "pointer",
    marginLeft: "auto", alignSelf: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    padding: "20px 0",
  },
  refreshBtn: {
    textTransform: "none",
    fontWeight: 600,
  },
  hideMobile: {
    "@media (max-width: 480px)": {
      display: "none",
    },
  },
  timestamp: {
    fontSize: 12,
    color: "#999",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  bottomFooter: {
    padding: "16px 20px",
    borderTop: "1px solid #e5e7eb",
    background: "#fff",
  },
  footerInner: {
    maxWidth: 1000,
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      textAlign: "center",
      gap: 8,
    },
  },
  footerLinks: {
    display: "flex",
    alignItems: "center",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      gap: 2,
    },
  },
  footerLink: {
    fontSize: 13,
    color: "#1a73e8",
    cursor: "pointer",
    textDecoration: "underline",
    margin: "0 8px",
    "&:hover": {
      color: "#0d47a1",
    },
  },
  footerDivider: {
    width: 1,
    height: 12,
    background: "#ccc",
    display: "inline-block",
    margin: "0 4px",
    verticalAlign: "middle",
  },
  copyright: {
    fontSize: 12,
    color: "#999",
    marginTop: 8,
  },
  errorBox: {
    textAlign: "center",
    padding: "60px 24px",
    background: "#fff",
    borderRadius: 12,
  },
  errorIcon: {
    fontSize: 64,
    color: "#d0d0d0",
    marginBottom: 16,
  },
  errorTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#1a1a1a",
    marginBottom: 8,
  },
  errorMsg: {
    fontSize: 14,
    color: "#888",
    marginBottom: 24,
  },
}))

const STATUS_MAP = {
  4: { bg: "#e8f5e9", color: "#2e7d32", label: "Scheduled" },
  5: { bg: "#e3f2fd", color: "#1565c0", label: "In Progress" },
  6: { bg: "#e3f2fd", color: "#1565c0", label: "In Progress" },
  7: { bg: "#e3f2fd", color: "#1565c0", label: "In Progress" },
}

const SchoolTracking = () => {
  const { schoolUuid } = useParams()
  const navigate = useNavigate()
  const cls = useStyles()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchData = () => {
    setLoading(true)
    setError(null)
    fetch(`/trips/api/v1/public/school/${schoolUuid}/`)
      .then((r) => {
        if (!r.ok) throw new Error(`School not found (${r.status})`)
        return r.json()
      })
      .then((json) => {
        setData(json)
        setLoading(false)
      })
      .catch((e) => {
        setError(e.message)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchData()
    const interval = setInterval(fetchData, 60000)
    return () => clearInterval(interval)
  }, [schoolUuid])

  const handleRideClick = (ride) => {
    if (ride.ride_group?.tracking_uuid) {
      navigate(`/track/${ride.ride_group.tracking_uuid}`)
    }
  }

  if (loading) {
    return (
      <Box className={cls.root}>
        <Box className={cls.loading}>
          <CircularProgress />
        </Box>
      </Box>
    )
  }

  if (error) {
    return (
      <Box className={cls.root}>
        <Box className={cls.header}>
          <Box className={cls.headerContent}>
            <Typography className={cls.headerTitle}>School Rides</Typography>
          </Box>
        </Box>
        <Box className={cls.content}>
          <Box className={cls.contentInner}>
          <Box className={cls.errorBox}>
            <ErrorOutlineIcon className={cls.errorIcon} />
            <Typography className={cls.errorTitle}>Unable to Load</Typography>
            <Typography className={cls.errorMsg}>{error}</Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={fetchData}
            >
              Try Again
            </Button>
          </Box>
          </Box>
        </Box>
      </Box>
    )
  }

  const { school, dates = [], total } = data?.data || data || {}

  const formatDateLabel = (dateStr) => {
    const todayStr = new Date().toISOString().slice(0, 10)
    if (dateStr === todayStr) return "Today"
    const d = new Date(dateStr + "T00:00:00")
    return d.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })
  }

  return (
    <Box className={cls.root}>
      <Box className={cls.header}>
        <Box className={cls.headerContent}>
          <Box className={cls.headerTitle}>
            <Box component="img" src={logoSrc} alt="Logo" style={{ height: 32, width: "auto" }} />
            {school?.name}
          </Box>
          <Box className={cls.headerRight}>
            {total > 0 && (
              <Typography className={cls.headerStat}>
                <DirectionsCarIcon /> {total}
                <Box component="span" className={cls.hideMobile}>
                  {" "}{total === 1 ? "Ride" : "Rides"}
                </Box>
              </Typography>
            )}
            <IconButton
              size="small"
              onClick={fetchData}
              style={{ color: "#fff" }}
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box className={cls.content}>
        <Box className={cls.contentInner}>
        {total === 0 && (
          <Box className={cls.emptyState}>
            <Box className={cls.emptyInner}>
              <Typography className={cls.emptyTitle} style={{ textAlign: "left" }}>Thanks for Checking In!</Typography>
              <Typography className={cls.emptyMsg} style={{ textAlign: "left" }}>
                It looks like there aren't any upcoming rides to display just yet.
              </Typography>
              <Typography className={cls.emptyMsg} style={{ textAlign: "left", marginTop: 12 }}>
                To ensure you always receive the most accurate information, your ride details, including your driver's live ETA, will become available 24 hours before your scheduled pickup.
              </Typography>
              <Typography className={cls.emptyMsg} style={{ textAlign: "left", marginTop: 12 }}>
                Until then, we hope you're having a wonderful day. Thank you for choosing Noah Cares. We look forward to seeing you on your next ride!
              </Typography>
            </Box>
          </Box>
        )}

        {dates.filter(g => g.rides.length > 0).map((dateGroup) => (
          <Box key={dateGroup.date} mb={2}>
            <Box className={cls.dateHeader}>
              <Typography className={cls.dateLabel}>
                {formatDateLabel(dateGroup.date)}
              </Typography>
              <Typography className={cls.dateCount}>
                {dateGroup.rides.length} {dateGroup.rides.length === 1 ? "ride" : "rides"}
              </Typography>
            </Box>
            {dateGroup.rides.map((ride) => {
              const statusInfo = STATUS_MAP[ride.status] || { bg: "#f5f5f5", color: "#666", label: `Status ${ride.status}` }
              return (
            <Card
              key={ride.trip_id}
              className={cls.card}
              onClick={() => handleRideClick(ride)}
              elevation={0}
            >
              <CardContent className={cls.cardContent}>
                <Box className={cls.cardHeader}>
                  <Box className={cls.clientSection}>
                    <Typography className={cls.clientName}>
                      Trip #{ride.trip_id}
                    </Typography>
                  </Box>
                  <span className={cls.statusBadge} style={{ background: statusInfo.bg, color: statusInfo.color }}>
                    {statusInfo.label}
                  </span>
                </Box>

                <Box className={cls.infoGroup}>
                  {ride.pickup_address?.address && (
                    <Box className={cls.infoRow}>
                      <RoomIcon className={cls.infoIcon} style={{ color: "#4caf50" }} />
                      <Box className={cls.infoContent}>
                        <Typography className={cls.infoLabel}>
                          Pickup{ride.pickup_time ? ` · ${new Date(ride.pickup_time).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true })}` : ""}
                        </Typography>
                        <Typography className={cls.infoText}>
                          {ride.pickup_address.address}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                <Box className={cls.infoGroup}>
                  {ride.drop_off_address?.address && (
                    <Box className={cls.infoRow}>
                      <FlagIcon className={cls.infoIcon} style={{ color: "#f44336" }} />
                      <Box className={cls.infoContent}>
                        <Typography className={cls.infoLabel}>
                          Drop-off{ride.drop_off_time ? ` · ${new Date(ride.drop_off_time).toLocaleTimeString([], { hour: "numeric", minute: "2-digit", hour12: true })}` : ""}
                        </Typography>
                        <Typography className={cls.infoText}>
                          {ride.drop_off_address.address}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>

                {ride.driver && (
                  <>
                    <div className={cls.driverRow}>
                      <Avatar
                        src={ride.driver.avatar || undefined}
                        style={{ width: 40, height: 40, background: "#1a73e8", fontSize: 17, fontWeight: 700 }}
                      >
                        {!ride.driver.avatar && ride.driver.name ? ride.driver.name.charAt(0).toUpperCase() : "D"}
                      </Avatar>
                      <div style={{ flex: 1 }}>
                        <div className={cls.driverName}>{ride.driver.name}</div>
                        {ride.driver.phone && (
                          <a href={`tel:${ride.driver.phone}`} style={{ textDecoration: "none" }}>
                            <div className={cls.driverPhone}>
                              <PhoneIcon style={{ fontSize: 14, verticalAlign: "middle", marginRight: 4 }} />
                              {ride.driver.phone}
                            </div>
                          </a>
                        )}
                      </div>
                      <div className={cls.trackBtn} onClick={() => navigate(`/track/${ride.ride_group.tracking_uuid}`)}>
                        Track →
                      </div>
                    </div>
                    {ride.driver.vehicle && (ride.driver.vehicle.make || ride.driver.vehicle.model || ride.driver.vehicle.color || ride.driver.vehicle.plate) && (
                      <div style={{ marginTop: 12 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                          <DirectionsCarIcon style={{ fontSize: 16, color: "#666" }} />
                          <span style={{ fontSize: 12, fontWeight: 600, color: "#666", textTransform: "uppercase", letterSpacing: 0.3 }}>Vehicle</span>
                        </div>
                        <div>
                          {[ride.driver.vehicle.color, ride.driver.vehicle.make, ride.driver.vehicle.model].filter(Boolean).map((v, i) => (
                            <span key={i} style={{ display: "inline-block", padding: "3px 10px", borderRadius: 8, background: "#e8f0fe", color: "#1a73e8", fontSize: 12, fontWeight: 500, marginRight: 6, marginBottom: 4 }}>{v}</span>
                          ))}
                          {ride.driver.vehicle.plate && <span style={{ fontSize: 13, color: "#555", marginLeft: 4 }}>Plate: {ride.driver.vehicle.plate}</span>}
                        </div>
                      </div>
                    )}
                  </>
                )}
              </CardContent>
            </Card>
            )})}
          </Box>
        ))}

        {total > 0 && (
          <Box className={cls.footer}>
            <IconButton
              variant="outlined"
              color="primary"
              onClick={fetchData}
              size="small"
            >
              <RefreshIcon />
            </IconButton>
          </Box>
        )}
        </Box>
      </Box>

      {/* Footer */}
      <Box className={cls.bottomFooter}>
        <Box className={cls.footerInner}>
          <Typography className={cls.copyright}>
            &copy; {new Date().getFullYear()} Noah Cares. All rights reserved.
          </Typography>
          <Box className={cls.footerLinks}>
            <span className={cls.footerLink} onClick={() => window.open("/privacy-policy", "_blank")}>
              Privacy Policy
            </span>
            <span className={cls.footerDivider} />
            <span className={cls.footerLink} onClick={() => window.open("/terms-conditions", "_blank")}>
              Terms & Conditions
            </span>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SchoolTracking
